const getApiHost = (fallback = process.env.REACT_APP_API_HOST) => {
  const { hostname, protocol: _protocol } = window.location;

  if (hostname === 'localhost') {
    return fallback;
  }
  if (hostname === 'signals-demo.nitro.run') {
    return 'https://signals-demo-v3.api.nitro.run';
  }
  if (hostname === 'signals-demo-prod.nitro.run') {
    return 'https://success.api.rocketlane.com';
  }
  if (hostname === 'agenttrigger.orbits.run') {
    return 'https://success.api.rocketlane.com';
  }
  if (hostname === 'signals-demo.orbits.run') {
    return 'https://success.api.rocketlane.com';
  }
  if (hostname === 'ai-analyst.orbits.run') {
    return 'https://success.api.rocketlane.com';
  }
  if (hostname === 'akshat.orbits.run') {
    return 'https://success.api.rocketlane.com';
  }
  if (hostname === 'chargebee-signals-demo.nitro.run') {
    return 'https://ps-chargebee.api.rocketlane.com';
  }
  if (hostname === 'tipalti-signals-demo.nitro.run') {
    return 'https://tipalti.api.rocketlane.com';
  }
  if (
    hostname === 'tsia-demo.nitro.run' ||
    hostname === 'tsia-demo.rocketlane.com'
  ) {
    return 'https://tsia-demo.api.rocketlane.com';
  }
  if (hostname === 'salesforce-v2.orbits.run') {
    return 'https://sf-autofetch-contacts.api.orbits.run';
  }

  const domainArr = hostname.split('.');
  const _subdomain = domainArr[0];

  return hostname.replace(_subdomain, `${_protocol}//${_subdomain}.api`);
};

const getApiNamespace = () => {
  const { hostname } = window.location;

  if (hostname === 'salesforce-v2.orbits.run') {
    return 'api';
  }

  return 'scarlet_api';
};

export const API_HOST = getApiHost('');
export const API_VERSION = 'v1';
export const API_NAMESPACE = getApiNamespace();
export const API_HOST_AGENTS =
  'https://conversation-service.rl-platforms.rocketlane.com';
export const AG_GRID_LICENSE_KEY =
  process.env.REACT_APP_AG_GRID_LICENSE_KEY || '';
export const TIPTAP_COLLAB_BASE_URL =
  process.env.TIPTAP_COLLAB_BASE_URL ||
  'https://tiptap-collab.api.rocketlane.com';
export const TIPTAP_CONVERTER_APP_ID =
  process.env.TIPTAP_CONVERTER_APP_ID || '';
